import { assignResourceToTasks } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';
import { useQueryClient } from 'react-query';

export const useAssignTask = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) => {
  const queryClient = useQueryClient();
  const { mutate, error, status } = useMutate(
    ['assign-task'],
    assignResourceToTasks,
    (data) => {
      queryClient.invalidateQueries(['resource-tasks-assigned']);
      queryClient.invalidateQueries(['resource-tasks-unassigned']);
      queryClient.invalidateQueries(['schedule-data']);
      queryClient.invalidateQueries(['schedule-data-infinite']);
      // casting because the data coming from param is set to unknown in hook
      responseFn(data as { success: boolean });
    }
  );

  return {
    mutate,
    error,
    status,
  };
};
